"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyMaxHeightModifier = void 0;
var _checkMaxHeightModifier = require("./checkMaxHeightModifier");
// Modifer to apply the styles from checkMaxHeightModifier.
const applyMaxHeightModifier = {
  name: "applyMaxHeight",
  enabled: true,
  phase: "main",
  requiresIfExists: ["offset", "preventOverflow", "checkMaxHeight"],
  fn(_ref) {
    let {
      state
    } = _ref;
    if ((0, _checkMaxHeightModifier.hasCheckMaxHeightModifierData)(state.modifiersData.checkMaxHeight) && state.modifiersData.checkMaxHeight.height) {
      // 16px = 2 * 8px padding top/bottom, and 32px to add some gap between the window edge and Menu.
      state.elements.popper.style.maxHeight = state.modifiersData.checkMaxHeight.height - 16 - 32 + "px";
    }
  }
};
exports.applyMaxHeightModifier = applyMaxHeightModifier;
//# sourceMappingURL=applyMaxHeightModifier.js.map